<template>
  <div class="new-main">
    <div class="news-tabs">
      <button
        @click="activeTab = '企业动态'"
        :class="{ active: activeTab === '企业动态' }"
      >
        {{ $t("companyNews") }}
      </button>
      <button
        @click="activeTab = '行业新闻'"
        :class="{ active: activeTab === '行业新闻' }"
      >
        {{ $t("industryNews") }}
      </button>
    </div>
    <!-- 企业动态 -->
    <!-- <div v-if="activeTab === '企业动态'" -->
    <div class="news-list">
      <div
        v-for="news in newsList"
        :key="news.id"
        class="news-item"
        @click="showModal(news)"
      >
        <div class="news-item-image">
          <img :src="news.picture" :alt="news.title" />
        </div>
        <div class="news-item-content">
          <div class="news-item-title">{{ news.title }}</div>
          <div class="news-item-dec">{{ news.describe }}</div>
          <div class="news-item-time">{{ news.createTime }}</div>
        </div>
      </div>
      <div style="width: 100%;float:left;display:flex;justify-content:center">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="pageNum"
          @current-change="handleCurrenChange"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 行业新闻 -->
    <!-- <div v-if="activeTab === '行业新闻'" class="news-list">
      <div
        v-for="news in $newsList"
        :key="news.id"
        class="news-item"
        @click="showModaltwo(news)"
      >
        <div class="news-item-image">
          <img :src="news.picture" :alt="news.title" />
        </div>
        <div class="news-item-content">
          <div class="news-item-title">{{ news.title }}</div>
          <div class="news-item-dec">{{ news.describe }}</div>
          <div class="news-item-time">{{ news.createTime }}</div>
        </div>
      </div>
  </div> -->
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      activeTab: "企业动态",
      selectednews: null,
      pageNum:1,
      pageSize:10,
      newsList:[],
      type:0,
      total:0
    };
  },
  computed:{
    lang(){
      return this.$store.state.lang
    }
  },
  methods: {
    showModal(news) {
      // this.selectednews = news;
      // this.isModalVisible = true;
      console.log('跳转')
      this.$router.push({
        path:'/news/details',
        query:{
          parentId: news.parentId,
          languageId:this.lang
        }
      })
    },
    getPage(){
      request.get('/hkbr/news/listNoToken', {
        params:{
        type:this.type,
        languageId: this.lang,
        pageSize:this.pageSize,
        pageNum:this.pageNum
      }
      }).then(data=>{
        this.newsList=data.rows
        this.total = data.total
      })
    },
    handleCurrenChange(val){
      this.pageNum = val
      this.getPage()
    }
  },
  watch:{
    lang:{
        handler:function(val){
          if(val){
          this.getPage()
          }
        },
        immediate:true
    },
    activeTab(val){
      this.pageNum = 1
      if(val=='企业动态'){
        this.type = 0
      }else{
        this.type = 1
      }
      this.getPage()
    }
  }
};
</script>

<style scoped>
.new-main {
  /* float: left; */
  width: 100%;
}
.news-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.news-tabs button {
  padding: 12px 30px;
  margin: 20px 10px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  font-size: 18px;
}

.news-tabs button.active {
  background-color: #d1261e;
  color: white;
}

.news-list {
  width: 1200px;
  margin: 0 auto;
}

.news-item {
  float: left;
  width: 100%;
  border: 1px solid #ddd;
  box-sizing: border-box;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: start;
  padding: 5px;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.news-item-image {
  float: left;
  width: 25%;
  height: 185px;
  margin-right: 10px;
}

.news-item-image img {
  float: left;
  width: 100%;
  height: 185px;
}

.news-item-content {
  float: left;
  width: 75%;
  height: 185px;
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
}

.news-item-title {
  font-size: 24px;
  color: #333333;
  line-height: 32px;
  height: 35px;
  overflow: hidden;
  margin-bottom: 10px;
}
.news-item-dec {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  height: 38px;
  overflow: hidden;
  line-height: 18px;
  margin-bottom: 20px;
}

.news-item-time {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
  line-height: 18px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 70%;
  position: relative;
  border-radius: 5px;
}

.selectedProduct-box {
  width: 100%;
  text-align: center;
}
.selectedProduct-img {
  width: 50%;
  margin-bottom: 20px;
}
.product-title-dec {
  background: #f6f6f6;
  color: #4a4a4a;
  font-size: 24px;
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 20px;
}

.close {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 40px;
  cursor: pointer;
}
.model {
  border: 1px solid #ddd;
  padding: 10px 20px;
  box-sizing: border-box;
}
.model-li {
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
}

.modal-body {
  margin-top: 20px;
  height: 700px;
  overflow-y: auto;
}

@media (max-width: 1200px) {
  .news-list {
    float: left;
    width: 100%;
  }
  .news-item {
    flex-direction: column;
  }
  .news-item-image {
    float: left;
    width: 100%;
    height: 185px;
  }

  .news-item-image img {
    float: left;
    width: 100%;
    height: 185px;
  }
  .news-item-content {
    width: 100%;
  }
  .modal-content {
    width: 80%;
  }
  .selectedProduct-img {
    width: 100%;
  }
  .product-item {
    width: 47%;
    margin: 10px 1%;
  }
  .modal-body {
    height: 500px;
  }
}
</style>